import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  label: {
    fontSize: '14px',
    color: 'rgba(39, 58, 57, 0.8)',
  },
  formControl: {
    margin: theme.spacing(3),
    fontSize: '14px',
    color: 'rgba(39, 58, 57, 0.8)',
  },
}));